import { Input } from "antd";
import { SearchIcon } from "icons/Icons";
import { IFilterValue, RoamingItemPopUpFilterColumnProps } from "domain/RoamingItems";
import { IColumnData } from "domain/order";

const RoamingItemPopUpFilterColumn = ({
  columns,
  searchValues,
  handleFilterChange,
  tableData,
  setSelectedRows,
}: RoamingItemPopUpFilterColumnProps) => {
  return columns.map((column: IColumnData) => {
    const columnIndex = column?.dataIndex || column?.key;
    if (!columnIndex || !column.title) return column;

    const isRoamingCol = columnIndex === "isRoaming";

    return {
      ...column,
      filterDropdownVisible: false,
      title: (
        <div>
          {isRoamingCol ? (
            <label className="custom-checkbox">
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    const notRoaming = tableData.filter((obj) => !obj.is_roaming);
                    setSelectedRows(notRoaming);
                  } else {
                    setSelectedRows([]);
                  }
                }}
              />
              <span className="checkmark"></span>
            </label>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label htmlFor={column.title}>{column.title}</label>
              <Input
                placeholder={`Search ${column.title}`}
                name={column.title}
                className="filter-input"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                value={searchValues[columnIndex as keyof IFilterValue] || ""}
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleFilterChange(e, columnIndex as string);
                }}
              />
            </div>
          )}
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchIcon fill={filtered ? "#1890ff" : undefined} />
      ),
    };
  });
};

export default RoamingItemPopUpFilterColumn;
